<template>
  <div>
    <b>Proformas:</b>
    <b-table small :fields="fields" :items="filteredSalesOrders" responsive="sm">
      <!-- A virtual column -->
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <!-- A custom formatted column -->
      <template #cell(orderID)="data">
        <b-tooltip title="View Proforma" placement="top">
        <a @click.prevent="goToOrderPage(data.item.orderID)" style="cursor: pointer;">
          {{ data.item.orderNumber }}
        </a>
      </b-tooltip>
      </template>

      <template #cell(productName)="data">
        <b-tooltip title="View Product" placement="top">
        <a @click.prevent="goToProductPage(data.item.productid)" style="cursor: pointer; color: blue; text-decoration: underline;">
          {{ data.item.productName }}
        </a>
      </b-tooltip>
      </template>

      <template #cell(customerName)="data">
        {{ data.item.customerName }}
      </template>

      <template #cell(issuedDate)="data">
        {{ dayjs(data.value).format("DD/MM/YYYY") }}
      </template>

      <template #cell(deliveryDate)="data">
        {{ dayjs(data.value).format("DD/MM/YYYY") }}
      </template>

      <!-- A custom formatted column -->
      <template #cell(Popularity)="data">
        <b-progress :value="data.value.value" max="100" :variant="data.value.variant" striped />
      </template>

      <template #cell(order_status)="data">
        <b-badge pill :variant="data.value.variant">
          {{ data.value.status }}
        </b-badge>
      </template>

      <template #cell(document)="data">
        <b-button variant="primary" class="mt-0 mt-md-1 mr-2" @click="handleDocumentBtn(data.item.productid)">
          <span>View Document</span>
        </b-button> 
      </template>
      <!-- A virtual composite column -->
      <template #cell(price)="data">
        {{ "$" + data.value }}
      </template>
    </b-table>
    <br />
    <b>Push Orders:</b>
    <b-table small :fields="fieldsNew" :items="pushOrders" responsive="sm">
      <!-- A virtual column -->
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <!-- A custom formatted column -->
      <template #cell(orderID)="data">
        {{ data.item.orderNumber }}
      </template>

      <template #cell(productName)="data">
        <b-tooltip title="View Product" placement="top">
        <a @click.prevent="goToProductPage(data.item.productid)" style="cursor: pointer; color: blue; text-decoration: underline;">
          {{ data.item.productName }}
        </a>
      </b-tooltip>
      </template>

      <template #cell(issuedDate)="data">
        {{ dayjs(data.value).format("DD/MM/YYYY") }}
      </template>

      <template #cell(deliveryDate)="data">
        {{ dayjs(data.value).format("DD/MM/YYYY") }}
      </template>

      <template #cell(orderComment)="data">
        <span v-if="!data.item.orderComment"> - </span>
        <span v-else-if="data.item.orderComment"> {{ data.item.orderComment }} </span>
      </template>

      <!-- A custom formatted column -->
      <template #cell(Popularity)="data">
        <b-progress :value="data.value.value" max="100" :variant="data.value.variant" striped />
      </template>

      <template #cell(order_status)="data">
        <b-badge pill :variant="data.value.variant">
          {{ data.value.status }}
        </b-badge>
      </template>

      <template #cell(document)="data">
        <b-button variant="primary" class="mt-0 mt-md-1 mr-2" @click="handleDocumentBtn(data.item.productid)">
          <span>View Document</span>
        </b-button> 
      </template>
      <!-- A virtual composite column -->
      <template #cell(price)="data">
        {{ "$" + data.value }}
      </template>
    </b-table>
    
<!-- Document Modal -->
 
<b-modal ref="modal-view-product-document" id="modal-view-product-document" ok-only ok-title="View" centered size="lg" title="View Product Documents" :hide-footer="true">
  <DocumentUpload
    @downloadFile="downloadFile"
    :documentDetails="documentDetails"
    :viewOnly="true"
  />
  </b-modal>
  <!-- Document Modal -->
  </div>
</template>

<script>
import { BTable, BProgress, BBadge,
  BButton, } from "bootstrap-vue";
  import Ripple from "vue-ripple-directive";
import dayjs from "dayjs";
import { mapActions, mapGetters } from "vuex";
import DocumentUpload from "@/views/component/DocumentUpload.vue";

export default {
  components: {
    BTable,
    BProgress,
    BBadge,
    BButton,
    DocumentUpload
  },
  data() {
    return {
      fields: [
        // A virtual column that doesn't exist in items
        "index",
        // A column that needs custom formatting
        { key: "orderID", label: "ORDER ID" },
        { key: "productName", label: "Product Name" },
        { key: "customerName", label: "Customer Name" },
        "issuedDate",
        // A regular column
        { key: "deliveryDate", label: "Due Date" },
        { key: "quantity", label: "Quantity" },
        "Document"

        // A regular column

        // A virtual column made up from two fields
      ],
      fieldsNew: [
        // A virtual column that doesn't exist in items
        "index",
        // A column that needs custom formatting
        { key: "orderID", label: "ORDER ID" },
        { key: "productName", label: "Product Name" },
        "issuedDate",
        // A regular column
        { key: "deliveryDate", label: "Due Date" },
        { key: "quantity", label: "Quantity" },
        { key: "orderComment", label: "Comment" },
        // A regular column
        "Document"

        
        // A virtual column made up from two fields
      ],
      dayjs,
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
    };
  },
  computed: {
    filteredSalesOrders() {
      return this.salesOrders.filter((order) => order.inHouse  === true || order.inHouse  === "true");
    },
    ...mapGetters("productModule", {
      loading: "loading",
      documents: "documents",
      file: "file",
    }),
  },
  methods: {
    ...mapActions("productModule", ["getProductDocumentListAction"]),
    goToProductPage(productId) {
    const url = `/product/stockTransaction/${productId}`;
    window.open(url, '_blank'); // '_blank' opens the link in a new tab
  },
  goToOrderPage(orderID) {
    const url = `/proforma/view/${orderID}`;
    window.open(url, '_blank'); // '_blank' opens the link in a new tab
  },
    async handleDocumentBtn(productId) {
      try {
        await this.getProductDocumentListAction(productId);
        if (this.documents.length > 0) {
          this.documentDetails.documentList = this.documents;
          this.documentDetails.isDelete = true;
        }
        this.$refs["modal-view-product-document"].show();
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    },
    async downloadFile(id, fileName) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document is being prepared for download',
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadProductDocument(id);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: response.headers['content-type'] || 'application/octet-stream',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error('Download failed:', error);
        loader.close();
        this.error('Failed to download the file. Please try again.'); // Updated error message for better clarity
      }
    },

},

  props: {
    salesOrders: {
      type: Array,
      default: () => [],
    },
    pushOrders: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
